import { render, staticRenderFns } from "./healthInfo.vue?vue&type=template&id=c37c26f2&scoped=true"
import script from "./healthInfo.vue?vue&type=script&lang=js"
export * from "./healthInfo.vue?vue&type=script&lang=js"
import style0 from "./healthInfo.vue?vue&type=style&index=0&id=c37c26f2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37c26f2",
  null
  
)

export default component.exports